// extracted by mini-css-extract-plugin
export default {"button":"_5qjb6CeNyc2TK7RSbvoc","primary":"e38JTh_wgDW7q7KKQN6S","secondary":"A8YFeSfYtUCekl_hljuo"};